import {
    HttpResponse,
    MaterialModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class MaterialsDataService implements CrudService<MaterialModel, MaterialModel> {
    getAll(query: CrudDataQuery<MaterialModel>): Promise<CrudEnumerableResponse<MaterialModel>> {
        return ApiService.api.getMaterialBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<MaterialModel>): Promise<CrudEnumerableResponse<MaterialModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<MaterialModel>> {
        return ApiService.api.getMaterialById(id, params);
    }

    create(item: MaterialModel, params?: RequestParams): Promise<CrudResponse<MaterialModel>> {
        return ApiService.api.insertMaterial(item, params);
    }

    update(item: MaterialModel, params?: RequestParams): Promise<MaterialModel> {
        return ApiService.api.updateMaterial(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<MaterialModel> {
        return ApiService.api.patchMaterial(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<MaterialModel>): Promise<CrudEnumerableResponse<MaterialModel>> {
        return ApiService.api.deleteMaterials(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationMaterial(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<MaterialModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: MaterialModel, params?: RequestParams): Promise<CrudResponse<MaterialModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getMaterialGroupped(query, params);
    }

}
